import { CUSTOMER_IDS } from '@/constants'

const customMenu = {}

customMenu[CUSTOMER_IDS.CITIZENM] = [{
  title: 'Entities',
  name: 'hotel-entities',
  link: process.env.VUE_APP_CITIZENM_CUSTOM_URL,
  icon: 'warehouse',
  privilege: 'SITE_CITIZENM_CUSTOM'
}]

customMenu[CUSTOMER_IDS.TOOLNATION] = [{
  title: 'Print Label',
  name: 'print-label',
  link: process.env.VUE_APP_TOOLNATION_CUSTOM_URL,
  icon: 'warehouse',
  privilege: 'SITE_TOOLNATION_CUSTOM'
}]

export default customMenu
